import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-depo-multi-select',
  templateUrl: './depo-multi-select.component.html',
  styleUrls: ['./depo-multi-select.component.scss']
})
export class DepoMultiSelectComponent implements OnChanges {

  @Input() depots: string[] = [];

  @Output() select: EventEmitter<any> = new EventEmitter<any>();

  _depots: string[];
  newDepots: string[];

  constructor() { }

  ngOnChanges() {
    this._depots = cloneDeep(this.depots);
    this.newDepots = cloneDeep(this.depots);
  }

  onClick(item: string) {
    const index = this.getIndex(item);
    if (index >= 0)
      this.newDepots.splice(index, 1);
    else
      this.newDepots.push(item);
    // emit event
    this.select.emit(this.newDepots);
  }

  selectAll() {
    if (this.isAllChecked())
      this.newDepots = [];
    else
      this.newDepots = cloneDeep(this.depots);
    // emit event
    this.select.emit(this.newDepots);
  }

  getIndex(item: string) {
    return this.newDepots.indexOf(item);
  }

  isAllChecked() {
    if (!this._depots || !this.newDepots) return;
    return this._depots.length === this.newDepots.length;
  }

}
